import fetch from './fetch';
import { PaymentMethodApi } from './paymentMethod.types';

export const getPaymentProviderListByPlanId = (planId: string): PaymentMethodApi => {
  return fetch('GET', `/offers/${planId}/payment-providers`);
};
